import { cn } from "cn"
import { LoaderCircle } from "lucide-react"

/** A spinning loader, labelled for screen readers. Put the text of what is loading next to it when there is room. */
function Spinner({ className, label = "Loading", ...props }: React.ComponentProps<"svg"> & { label?: string }) {
  return (
    <LoaderCircle
      data-slot="spinner"
      role="img"
      aria-label={label}
      className={cn("size-4 animate-spin text-subtle-foreground", className)}
      {...props}
    />
  )
}

export { Spinner }
